import React from 'react';
import FormItemButtonBaseControl from './FormItemButtonBaseControl';
import FormItemButtonMenu from '../FormItemButtonMenu';
import FormItemUtil from '../../utils/FormItemUtil';
import CmdTypeActions from '../../actions/CmdTypeActions';

export default class FormItemButtonMenuControl extends FormItemButtonBaseControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemButtonMenuControl";
	}

	getStyle()
	{
		let _style = {};
		let layout = this.parentXML.Properties.Layout.Value;
		let parentType = this.parentXML.type;
		if(parentType == "ButtonGroup" && layout == "vertical")
		{
			_style["alignSelf"] = 'stretch';
		}
		
			/*_style["padding-left"] = '3px';
    		_style["padding-right"] = '1px';
    		_style["margin-top"] = '3px';
		}
		else
		{
			_style["margin"] = '3px';
		}*/
		return _style;
	}
	
	getButtonMenuDropDown()
	{
		let parent = this.xml;
		let children = parent.FormItem;
		let menuItemId = this.menuItemId;let formId = this.formId;let forLookup = this.forLookup;let controlId = this.controlId;
		var ul = $("<ul>").addClass("dropdown-menu").css({display:"block",overflow:"auto"}).attr("role","menu");
		let list = children.map(function(item){
			 let key = FormItemUtil.getFormItemControlKey(menuItemId,formId,item.id)
			 let control = FormItemUtil.getFormItemControl(key,forLookup);
             let $buttonItem = control.getJqueryItemUnderButtonMenu(parent,forLookup);
             ul.append($buttonItem);
  		 });
		
		return ul;
	}

	doSetEnableCmd(value)
	{
		this._cmdEditFalse = !value;
		CmdTypeActions.updateControlAllowEdit(this.xml.name,value);
		/*if(this.childrenControl && this.childrenControl.length>0)
		{
			var finalValue = this.getProperty_AllowEdit_Final();
			for(let i = 0;i<this.childrenControl.length;i++)
			{
				var item = this.childrenControl[i];
				item.doSetEnableCmd(finalValue);
			}
		}*/
	}

	getComponentInstance(parent,forLookup)
	{
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
	  	this.component = <FormItemButtonMenu key={this.xml.id} xml={this.xml} control={this} 
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId} 
                label={label} customStyle={this.getStyle()} menuItemId={this.menuItemId} iconClass={this.getProperty_Icon()}
                formId={this.formId} dropdown={this.getButtonMenuDropDown()} {...commonProps}/>;
        return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemButtonMenuControl.js